import type { CameraRoute } from '@datum-sdk/scene-format';

/**
 * The 605 C.E preloader flights, as SDK scene data: the tour, then a flyover
 * that climbs off `previewTourEnd`, sweeps 160° round the Kaaba and settles on
 * the rest pose — its last view.
 *
 * Converted once from the legacy `kaaba605SceneConfig.camera` by
 * `convertLegacyPreloader.ts` (which says what in here is load-bearing); the
 * routes are the source since. Tune them in the SDK editor (`?flight` → Routes →
 * Copy Routes) — the same workflow as `kaabaRoutes.ts` — and
 * `sceneRoutes.test.ts` holds them to what the preloader and the scene need.
 */
export const KAABA_605_CAMERA_ROUTES: CameraRoute[] = [
  {
    id: 'preview-enter',
    waypoints: [
      {
        target: [-5.78, 3.17, 2.61],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
      {
        orbit: {
          radius: 6.931413997,
          azimuth: 2.891110227,
          polar: 1.134359289,
        },
        target: [-0.08, 0.24, -0.03],
        lookAt: 'target',
        duration: 500,
        easing: [0.333333333, 0, 0.666666667, 0.333333333],
      },
    ],
  },
  {
    id: 'preview-turntable',
    loop: true,
    waypoints: [
      {
        orbit: {
          radius: 6.931413997,
          azimuth: 4.461906554,
          polar: 1.134359289,
        },
        target: [-0.08, 0.24, -0.03],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.931413997,
          azimuth: 6.032702881,
          polar: 1.134359289,
        },
        target: [-0.08, 0.24, -0.03],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.931413997,
          azimuth: 7.603499208,
          polar: 1.134359289,
        },
        target: [-0.08, 0.24, -0.03],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.931413997,
          azimuth: 9.174295535,
          polar: 1.134359289,
        },
        target: [-0.08, 0.24, -0.03],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
    ],
  },
  {
    id: 'preview-exit',
    waypoints: [
      {
        target: [1.46, 0.39, -2.43],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
    ],
  },
  {
    id: 'preloader-flyover',
    waypoints: [
      {
        duration: 1000,
      },
      {
        kind: 'view',
        position: [1.46, 2.101, -2.43],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 1000,
        easing: [0.333333333, 0, 0.666666667, 0.377960679],
      },
      {
        kind: 'view',
        position: [2.18829626, 2.101, -1.758796135],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 287.567910188,
        easing: [0.333333333, 0.305869121, 0.666666667, 0.642216803],
      },
      {
        kind: 'view',
        position: [2.642784359, 2.101, -0.878733959],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 250.333891222,
        easing: [0.333333333, 0.31851732, 0.666666667, 0.653806101],
      },
      {
        kind: 'view',
        position: [2.768864481, 2.101, 0.103698059],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 235.228959772,
        easing: [0.333333333, 0.325306611, 0.666666667, 0.660263638],
      },
      {
        kind: 'view',
        position: [2.551329501, 2.101, 1.070004117],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 228.685999965,
        easing: [0.333333333, 0.330286499, 0.666666667, 0.665112389],
      },
      {
        kind: 'view',
        position: [2.016417349, 2.101, 1.903633445],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 228.584788812,
        easing: [0.333333333, 0.334739398, 0.666666667, 0.669563317],
      },
      {
        kind: 'view',
        position: [1.228646325, 2.101, 2.504038042],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 234.895636162,
        easing: [0.333333333, 0.339559492, 0.666666667, 0.67450966],
      },
      {
        kind: 'view',
        position: [0.283033241, 2.101, 2.798800252],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 249.649113567,
        easing: [0.333333333, 0.345933948, 0.666666667, 0.681206777],
      },
      {
        kind: 'view',
        position: [-0.70636701, 2.101, 2.752367404],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 285.053700313,
        easing: [0.333333333, 0.357151256, 0.666666667, 0.693446231],
      },
      {
        kind: 'view',
        position: [-0.928, 1.111, 4.222],
        lookAt: [-0.08, 0.24, -0.03],
        duration: 1000,
        easing: [0.333333333, 0.601107218, 0.666666667, 1],
      },
    ],
  },
];
